import { Pipe, PipeTransform } from '@angular/core';
import {BottomSheetComponent} from "../../shared/components/bottom-sheet/bottom-sheet.component";

@Pipe({
  name: 'bottomSheetAvailable',
  standalone: true
})
export class BottomSheetAvailablePipe implements PipeTransform {

  transform(bottomSheetComponent: BottomSheetComponent, constraint: boolean): boolean {
    if (constraint !== undefined) {
      if (constraint === false) {
        void bottomSheetComponent.closeIfPresented(false);
      }

      return constraint;
    }

    return false;
  }

}
